import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { axiosInstance } from '../../axios/interceptor'

export const getAdminHostTasks = createAsyncThunk('hostTask/list', async (params, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`/host-tasks/admin/list`, { params })
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const getAdminHostTaskDetail = createAsyncThunk('hostTask/detail', async (id, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`/host-tasks/admin/detail/${id}`)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const getAdminHostTaskStats = createAsyncThunk('hostTask/stats', async (params, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`/host-tasks/admin/stats`, { params })
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

const initialState = {
  isLoading: false,
  tasks: [],
  taskDetail: null,
  stats: null,
  totalRecords: 0,
  error: null
}

const hostTaskSlice = createSlice({
  name: 'hostTask',
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getAdminHostTasks.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getAdminHostTasks.fulfilled, (state, action) => {
        state.isLoading = false
        state.tasks = action.payload?.data?.data?.hostTasks || []
        state.totalRecords = action.payload?.data?.data?.totalRecords || 0
      })
      .addCase(getAdminHostTasks.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(getAdminHostTaskDetail.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getAdminHostTaskDetail.fulfilled, (state, action) => {
        state.isLoading = false
        state.taskDetail = action.payload?.data?.data
      })
      .addCase(getAdminHostTaskDetail.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(getAdminHostTaskStats.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getAdminHostTaskStats.fulfilled, (state, action) => {
        state.isLoading = false
        const statusCounts = action.payload?.data?.data?.statusCounts || []
        const statsMap = {}
        statusCounts.forEach((item) => {
          statsMap[item.status] = Number(item.count) || 0
        })
        state.stats = statsMap
      })
      .addCase(getAdminHostTaskStats.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
  }
})

export default hostTaskSlice.reducer
